import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path d="M19 16a2.91 2.91 0 0 0-.14-.89 1.48 1.48 0 0 1-1.36.89 1.5 1.5 0 0 1-1.5-1.5 1.48 1.48 0 0 1 .89-1.36A2.91 2.91 0 0 0 16 13a3 3 0 1 0 3 3Z"></path><path fill-rule="evenodd" d="M29.53 14.7C24.7 9 20.12 7 16.11 7 9.69 7 4.72 12 2.46 14.72a2 2 0 0 0 0 2.58C7.3 23 11.88 25 15.89 25c6.42 0 11.39-5 13.65-7.72a2 2 0 0 0-.01-2.58ZM4 16a24.081 24.081 0 0 1 5.88-5.15A8 8 0 0 0 10 21.3 23.16 23.16 0 0 1 4 16Zm6 0a6 6 0 1 0 12 0 6 6 0 0 0-12 0Zm12.13 5.14A8 8 0 0 0 22 10.7a23.16 23.16 0 0 1 6 5.3 24.08 24.08 0 0 1-5.87 5.14Z" clip-rule="evenodd"></path></g>';
export var EyeOpenOutlineSVG = function EyeOpenOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
EyeOpenOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(EyeOpenOutlineSVG);